/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S3_HeadingInputs */

const tr_onbilgi_s3_heading = /** @type {(inputs: Onbilgi_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Toplam Bedel`)
};

const en_onbilgi_s3_heading = /** @type {(inputs: Onbilgi_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Total Price`)
};

const de_onbilgi_s3_heading = /** @type {(inputs: Onbilgi_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Gesamtpreis`)
};

const ru_onbilgi_s3_heading = /** @type {(inputs: Onbilgi_S3_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Общая стоимость`)
};

/**
* | output |
* | --- |
* | "3. Total Price" |
*
* @param {Onbilgi_S3_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s3_heading = /** @type {((inputs?: Onbilgi_S3_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S3_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s3_heading(inputs)
	if (locale === "de") return de_onbilgi_s3_heading(inputs)
	if (locale === "ru") return ru_onbilgi_s3_heading(inputs)
	return tr_onbilgi_s3_heading(inputs)
});